import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Pagination } from "../../shared/pagination.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { ApiResponseModel, PagingResponseModel } from "../../shared/api-response.model";
import { Core2Config } from "../../shared/core2Config";

import { ApiVisa } from "../../shared/api-visa.model";
import { Observable } from "rxjs";
import { StockReplenishmentEventHdrModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment-event-hdr.model";

@Injectable({ providedIn: "root" })
export class StockReplenishmentEventHdrService extends BaseApiTemplateService<StockReplenishmentEventHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    "erp/inv-stock-replenishment-event-hdrs/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/inv-stock-replenishment-event-hdrs/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/inv-stock-replenishment-event-hdrs/backoffice-ep";
    this.httpClient = theHttp;
  }

  deleteEvent(
    guid: string,
    deleteType: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      console.log(
        "this.endpoint_path && visa.api_domain_url: ",
        visa.api_domain_url + this.endpoint_path
      );
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + "/" + guid + "?delete_type=" + deleteType,
      this.getHttpHeader(visa)
    );
  }
}
